import styles from './StatsBar.module.css';

interface Stat {
  value: string;
  label: string;
}

interface StatsBarProps {
  stats?: Stat[];
}

const defaultStats: Stat[] = [
  { value: '50–90%', label: 'Improvement in data reliability' },
  { value: '80%', label: 'Faster AI/ML experimentation' },
  { value: '5×', label: 'Operational efficiency gains' },
  { value: '40–80%', label: 'Faster model deployment' },
];

export function StatsBar({ stats = defaultStats }: StatsBarProps) {
  return (
    <div className={styles.bar}>
      <div className={styles.inner}>
        {stats.map((stat) => (
          <div key={stat.label} className={styles.stat}>
            <div className={styles.value}>{stat.value}</div>
            <div className={styles.label}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
